<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Dodaj URL
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-textarea
                    v-model="form.urls"
                    :rules="formRules.urls"
                    class="pt-0"
                    rows="10"
                    label="Adresy URL"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
              >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalAddGoogleIndexing',
  props: {
    item: {},
  },
  mixins: [
  ],
  created() {
  },
  data() {
    return {
      dialog: false,
      form: {
        urls: '',
      },
      formRules: {
        urls: [(value) => !!value || 'Wpisz przynajmniej jeden URL'],
      },
      valid: false,
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const data = {
        urls: this.form.urls.split('\n'),
      }
      api
          .post('/api/google-indexing' , data)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Adres URL został dodany.',
            });
            this.dialog = false;
            this.form.url = '';
            this.$parent.get();
          })
          .catch((error) => {
            console.error('Error when adding a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
